var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classesTabs,attrs:{"id":_vm.id,"direction":_vm.direction,"role":"tablist"}},[_c('div',{staticClass:"adm-tabs__inner"},_vm._l((_vm.tabs),function(tab,index){return _c('adm-button',_vm._b({key:index,class:[
        'adm-tab',
        `adm-tab--${_vm.variant}`,
        { unselected: tab.value !== _vm.value && !tab.disabled }
      ],attrs:{"id":`${_vm.id}_tab_${tab.value}`,"disabled":tab.disabled,"leadingIcon":tab.leadingIcon,"size":_vm.size,"trailingIcon":tab.trailingIcon,"variant":_vm.variant,"role":"tab"},on:{"click":function($event){_vm.onChange(tab.value);
        _vm.handleClick($event, index);}}},'adm-button',tab.attrs,false),[_c('span',{domProps:{"innerHTML":_vm._s(tab.label)}})])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }